module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"risk-0":"レーダー・36時間予報","risk-1":"実積累加雨量","risk-2":"内水リスク予測","risk-3":"バーチャル水面","risk-4":"ゲリラ豪雨","risk-5":"アンサンブル流域予測雨量"},"en":{"risk-0":"Radar 36 hours forecast","risk-1":"cumulative rainfall","risk-2":"Flood forecast","risk-3":"water’s surface","risk-4":"\\"Guerilla rainstorm\\"","risk-5":"アンサンブル流域予測雨量"}}')
  delete Component.options._Ctor
}
